var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneRingingIcon = function SvgPhoneRingingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 35 35"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#PhoneRingingIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.433 18.373h-.015a6 6 0 0 0-5.08 5.533l-.08 1.184a2 2 0 0 0 1.862 2.13l4.989.334a2 2 0 0 0 2.129-1.861 2 2 0 0 1 2.13-1.862l7.981.535a2 2 0 0 1 1.862 2.13 2 2 0 0 0 1.862 2.13l4.988.334a2 2 0 0 0 2.13-1.861l.08-1.184a6 6 0 0 0-4.297-6.16h-.014a54.2 54.2 0 0 0-20.527-1.382M18.095 13.124l.469-6.985M11.11 12.655l-2.658-5.19M25.08 13.592l3.327-4.788"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PhoneRingingIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2.936.062 31.928 2.142-2.143 31.928L.793 31.99z"
  })))));
};
export default SvgPhoneRingingIcon;